import React, { useState, useEffect, useRef } from "react";
import { StyleSheet, Text, View, Animated, Dimensions } from "react-native";
import {
  buttonText,
  bodyTextFuturePage,
  bodyTextFuturePageMandGSA,
  custom4,
} from "../../../../../Utils/static-strings";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../../Utils/responsive";
import ContinueButton from "../../../../../Components/ContinueButton";
import clockIcon from "../../../../../assets/images/clock-regular-full.svg";

const deviceWidth = Dimensions.get("screen").width;
const textColor = "var(--text-color-default)";

const Index = (props) => {
  const isMandGSA =
    sessionStorage.getItem("skinName")?.toLowerCase() ===
    custom4?.toLowerCase();
  const animation = useState(new Animated.Value(0))[0];
  const imageOpacity = useRef(new Animated.Value(0)).current;
  const imageSize = Math.min(430, deviceWidth * 0.35);
  useEffect(() => {
    Animated.parallel([
      Animated.timing(animation, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: false,
      }),
      Animated.timing(imageOpacity, {
        toValue: 1,
        duration: 800,
        useNativeDriver: false,
      }),
    ]).start();
  }, []);

  const opacityInterpolate = animation.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  });

  const leftTextAnimationInterpolate = animation.interpolate({
    inputRange: [0, 1],
    outputRange: ["-50%", "0%"],
  });

  const { setPrePage, moduleObject } = props;

  if (isMandGSA) {
    const futureIntroLines = bodyTextFuturePageMandGSA.split("\n");

    return (
      <div
        style={{
          backgroundColor: "var(--game-background-color-pb)",
          height: "100%",
          width: "100%",
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 24,
          padding: 24,
        }}
      >
        <h1
          style={{
            fontSize: 32,
            letterSpacing: 1,
            margin: 0,
            color: textColor,
          }}
        >
          The Future
        </h1>
        {futureIntroLines.map((line) => (
          <p
            key={line}
            style={{
              maxWidth: 520,
              textAlign: "center",
              margin: 0,
              fontFamily: "Infra",
              fontSize: 18,
              lineHeight: "28px",
              color: textColor,
            }}
          >
            {line}
          </p>
        ))}
        <ContinueButton onClick={() => setPrePage(false)} />
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "var(--game-background-color-pb)",
        height: "100%",
        width: "100%",
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Animated.View
        style={{
          width: deviceWidth > 600 ? "82%" : "90%",
          height: "75%",
          justifyContent: "center",
          transform: [{ translateX: animation }],
        }}
      >
        <Text
          style={{
            fontFamily: "var(--font-family-heading)",
            fontSize: 60,
            lineHeight: 68,
            fontWeight: "var(--font-weight-semi-bold)",
            color: "#2f2f2f",
            marginBottom: hp("3%"),
          }}
        >
          The Future
        </Text>
        <Text style={styles.customText}>{bodyTextFuturePage}</Text>
        <View
          style={{
            flexDirection: "row",
            marginBottom: hp("3%"),
            height: 18,
          }}
        >
          <img
            src={clockIcon}
            alt=""
            style={{ width: 18, height: 18, objectFit: "contain" }}
          />
          <Text
            style={{
              fontSize: 14,
              fontFamily: "Infra",
              color: "#2f2f2f",
              paddingLeft: 10,
            }}
          >
            Typically 1 minute
          </Text>
        </View>
        <ContinueButton onClick={() => setPrePage(false)} text={buttonText} />
      </Animated.View>
      <View style={{ height: "25%", width: "100%" }} />
      <Animated.Image
        source={require("../../../../../assets/images/mandg/mandg-active-square-pb.png")}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: imageSize,
          height: imageSize,
          resizeMode: "contain",
          pointerEvents: "none",
          opacity: imageOpacity,
        }}
      />
    </div>
  );
};

export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh", // deviceWidth > 600 ? '85vh' : '88vh',
    width: "100vw",
    // flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  customText: {
    width:
      Dimensions.get("screen").width > 1300
        ? wp("60%")
        : Dimensions.get("screen").width > 700
          ? wp("60%")
          : wp("89%"),
    Height: hp("24.3%"),
    fontSize: 19,
    textAlign: "Left",
    color: "#2f2f2f",
    marginBottom: hp("3%"),
    fontFamily: "Infra",
    lineHeight: 24,
    alignSelf: "flex-start",
  },
});
